"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
var Ctx_1 = require("./Ctx");
var Cache = /** @class */ (function () {
    function Cache(opts) {
        this.cache = {};
        this.size = 0;
        this.ttl = opts.ttl || 0;
        this.resetTtl = opts.ttl > 0 && opts.resetTtl !== false;
    }
    Object.defineProperty(Cache.prototype, "log", {
        get: function () {
            return Ctx_1.Ctx.get.logger(this.constructor.name);
        },
        enumerable: false,
        configurable: true
    });
    Cache.prototype.get = function (key) {
        var item = this.cache[Symbol.for(key)];
        if (item) {
            if (this.resetTtl) {
                item.ttl = this.newTtl;
            }
            return item.value;
        }
    };
    Cache.prototype.has = function (key) {
        return this.cache.hasOwnProperty(Symbol.for(key));
    };
    Cache.prototype.set = function (key, value) {
        // Using Symbol for efficiency and performance
        // Typescript typing doesn't yet support symbols as keys - https://github.com/microsoft/TypeScript/issues/1863
        var skey = Symbol.for(key);
        var item = (this.cache[skey] = {
            key: skey,
            value: value,
            ttl: this.newTtl,
        });
        if (!this.first) {
            this.first = item;
        }
        if (this.last) {
            this.last.next = item;
            item.prev = this.last;
        }
        this.last = item;
        this.size++;
        this.timeout || this.evict(); // if eviction has not already been scheduled, trigger it
        return value;
    };
    Object.defineProperty(Cache.prototype, "newTtl", {
        get: function () {
            return this.ttl > 0 ? Date.now() + this.ttl : this.ttl;
        },
        enumerable: false,
        configurable: true
    });
    Cache.prototype.remove = function (key) {
        var skey = Symbol.for(key);
        var item = this.cache[skey];
        if (item) {
            if (item.prev) {
                item.prev.next = item.next;
            }
            if (item.next) {
                item.next.prev = item.prev;
            }
            delete this.cache[skey];
            this.size--;
        }
    };
    Cache.prototype.evict = function () {
        var _this = this;
        if (this.ttl === 0) {
            return;
        }
        try {
            this.timeout = undefined;
            var now = Date.now();
            var item = this.first;
            var prev = item ? item.prev : null;
            while (item) {
                if (item.ttl <= now) {
                    if (prev) {
                        prev.next = undefined;
                    }
                    if (item === this.first) {
                        this.first = undefined;
                    }
                    delete this.cache[item.key];
                    this.size--;
                }
                else {
                    if (!this.first) {
                        this.first = item;
                    }
                    if (prev) {
                        prev.next = item;
                    }
                    item.prev = prev;
                    prev = item;
                }
                item = item.next;
            }
            this.last = prev;
            if (this.size > 0) {
                this.timeout = setTimeout(function () { return _this.evict(); }, this.ttl);
                this.timeout.unref();
            }
        }
        catch (err) {
            this.log.error('evict', 'Unable to evict from cache so flusing cache ...', err);
            // Unable to evict from cache so flusing cache altogether so we don't run out of memory
            this.flush();
        }
    };
    Cache.prototype.flush = function () {
        this.cache = {};
        this.first = undefined;
        this.last = undefined;
        this.size = 0;
    };
    return Cache;
}());
exports.Cache = Cache;
